import ninjaApi from 'store/redux/apis/ninja.api';

export const hubspotApi = ninjaApi.injectEndpoints({
  overrideExisting: true,
  tagTypes: ['Integration'],
  endpoints: (build) => ({
    connectHubSpot: build.mutation({
      query: (data) => ({
        url: '/apps/hubspot/auth/connect',
        method: 'POST',
        data,
      }),
      invalidatesTags: ['Integration'],
    }),
  }),
});

export const { useConnectHubSpotMutation } = hubspotApi;
